import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Mascot } from "@/components/styleguide/Mascot";
import { api } from "./api";
import { useAuth } from "./AuthContext";

export default function AuthCallback() {
  const navigate    = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params    = new URLSearchParams(window.location.search);
    const code      = params.get("code");
    const googleErr = params.get("error");

    if (googleErr || !code) {
      navigate("/vocab", { replace: true });
      return;
    }

    const redirectUri = `${window.location.origin}/auth/callback`;

    api("/auth/google", {
      method: "POST",
      body:   { code, redirect_uri: redirectUri },
    })
      .then((userData) => {
        // Set user immediately in AuthContext — subscription fields included.
        // Then SPA-navigate so the dashboard renders with the full user object
        // already in place (no async /auth/me race on the next page).
        setUser(userData);
        navigate("/vocab/children", { replace: true });
      })
      .catch((e) => {
        setError(e.message || "Sign-in failed — please try again.");
        setTimeout(() => { window.location.href = "/vocab"; }, 3000);
      });
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center bg-gradient-to-b from-[#FFF7EF] to-[#DCF3EC] px-6 text-center">
      {error ? (
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
          <Mascot size={80} mood="happy" animated={false} />
          <p className="mt-4 font-display text-lg font-black text-foreground">Something went wrong</p>
          <p className="mt-1 text-sm font-semibold text-muted-foreground">{error}</p>
          <p className="mt-1 text-xs text-muted-foreground">Taking you back…</p>
        </motion.div>
      ) : (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex flex-col items-center gap-4">
          <motion.div animate={{ rotate: [0, 8, -8, 0] }} transition={{ duration: 1.4, repeat: Infinity }}>
            <Mascot size={80} mood="happy" animated={false} />
          </motion.div>
          <p className="font-display text-lg font-bold text-foreground">Signing you in…</p>
        </motion.div>
      )}
    </div>
  );
}